'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _trackEvent = require('../utils/trackEvent');

var _createTracker = require('../utils/createTracker');

var _createTracker2 = _interopRequireDefault(_createTracker);

var _isInitialised = require('../utils/isInitialised');

var _isInitialised2 = _interopRequireDefault(_isInitialised);

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.__hudlUserActivityTracking = {
  __hudlVideoActivityHeartbeatInterval: null
};

function getBrowserTimeMs() {
  return Math.floor(performance.now());
}

var VideoPlaybackHeartbeat = function () {
  function VideoPlaybackHeartbeat(config, context) {
    _classCallCheck(this, VideoPlaybackHeartbeat);

    if (this.instance) {
      return this.instance;
    }

    this.instance = this;
    this.__type = 'VideoPlaybackHeartbeat';

    var appVersion = config.appVersion,
        globalSnowplowName = config.globalSnowplowName,
        intervalMs = config.intervalMs,
        trackerName = config.trackerName,
        trackerSettings = config.trackerSettings,
        userId = config.userId;


    this.appVersion = appVersion;
    this.intervalMs = intervalMs;
    this.currentPlaytimeMs = 0;
    this.currentPlaybackRate = 1.0;
    this.globalSnowplowName = globalSnowplowName;

    this.isHeartbeatRunning = false;
    this.lastHeartbeatBrowserTimeMs = getBrowserTimeMs();

    // Create the tracker if calling the class to use standalone.
    if (!(0, _isInitialised2.default)(globalSnowplowName)) {
      (0, _createTracker2.default)(globalSnowplowName, userId, trackerName, trackerSettings);
    }

    this.context = context;
  }

  _createClass(VideoPlaybackHeartbeat, [{
    key: 'destructor',
    value: function destructor() {
      this.stop();
      this.instance = null;
    }
  }, {
    key: 'start',
    value: function start() {
      var _this = this;

      if (this.isHeartbeatRunning) {
        return;
      }

      this.isHeartbeatRunning = true;
      this.lastHeartbeatBrowserTimeMs = getBrowserTimeMs();

      window.__hudlUserActivityTracking.__hudlVideoActivityHeartbeatInterval = setInterval(function () {
        // Browser will fire interval slightly +/- from intervalMs; we want to
        // capture these small discrepancies.
        // We'll be depending on the reliable performance.now() rather than
        // purely browser setInterval execution which is unreliable under CPU load.
        var now = getBrowserTimeMs();
        _this.sendVideoActivityHeartbeatEvent(now - _this.lastHeartbeatBrowserTimeMs);
        _this.lastHeartbeatBrowserTimeMs = now;
      }, this.intervalMs);
    }
  }, {
    key: 'stop',
    value: function stop() {
      clearInterval(window.__hudlUserActivityTracking.__hudlVideoActivityHeartbeatInterval);
      if (!this.isHeartbeatRunning) {
        return;
      }

      this.isHeartbeatRunning = false;

      // Capture elapsed partial interval.
      var timeElapsedSinceLastHeartbeatMs = getBrowserTimeMs() - this.lastHeartbeatBrowserTimeMs;
      if (timeElapsedSinceLastHeartbeatMs === 0) {
        return;
      }
      this.sendVideoActivityHeartbeatEvent(timeElapsedSinceLastHeartbeatMs);
    }
  }, {
    key: 'setEventContext',
    value: function setEventContext(context) {
      if (!context) {
        return;
      }

      // If the heartbeat is already running, stop it to trigger a final heartbeat with the existing context
      if (this.isHeartbeatRunning) {
        this.stop();
        this.context = context;
        this.start();
      } else {
        this.context = context;
      }
    }
  }, {
    key: 'updateHeartbeatIntervalMs',
    value: function updateHeartbeatIntervalMs(intervalMs) {
      if (intervalMs === this.intervalMs) {
        return;
      }

      if (!this.isHeartbeatRunning) {
        this.intervalMs = intervalMs;
        return;
      }

      // Stop to account for interval between heartbeats and restart.
      this.stop();
      this.intervalMs = intervalMs;
      this.start();
    }
  }, {
    key: 'updateCurrentPlaybackTimeMs',
    value: function updateCurrentPlaybackTimeMs(currentPlaytimeMs) {
      this.currentPlaytimeMs = currentPlaytimeMs;
    }
  }, {
    key: 'updatePlaybackRate',
    value: function updatePlaybackRate(currentPlaybackRate) {
      if (currentPlaybackRate === this.currentPlaybackRate) {
        return;
      }

      if (!this.isHeartbeatRunning) {
        this.currentPlaybackRate = currentPlaybackRate;
        return;
      }

      // Stop to account for playback rate between heartbeats and restart.
      this.stop();
      this.currentPlaybackRate = currentPlaybackRate;
      this.start();
    }
  }, {
    key: 'sendVideoActivityHeartbeatEvent',
    value: function sendVideoActivityHeartbeatEvent(intervalMs) {
      var eventIntervalMs = intervalMs || this.intervalMs;

      // If the reported interval to log exceeds the config by a large percentage,
      // purposefully fail schema validation as this most likely indicates a defect
      // that could skew reporting rather than CPU load on the browser leading to
      // delayed setInterval execution by a small amount.
      if (eventIntervalMs > this.intervalMs * _constants.MAX_HEARTBEAT_VARIANCE) {
        eventIntervalMs = -1;
      }

      var event = {
        schema: _constants.VIDEO_ACTIVITY_HEARTBEAT_EVENT_SCHEMA,
        data: {
          app_version: this.appVersion,
          origin: '' + window.location.href + window.location.hash,
          interval_ms: eventIntervalMs,
          current_playtime_ms: this.currentPlaytimeMs,
          playback_rate: this.currentPlaybackRate
        }
      };

      (0, _trackEvent.trackCustomEvent)(this.globalSnowplowName, event, this.context);
    }
  }]);

  return VideoPlaybackHeartbeat;
}();

exports.default = VideoPlaybackHeartbeat;
module.exports = exports['default'];